const SYSTEM_SALES_LOG_PATTERNS = [
  /^New lead has been created/i,
  /^Stage updated:/i,
  /^Lead moved:/i,
  /^Qualification profile updated/i,
  /^Lead qualification answers were edited/i,
  /^Lead kept active despite Nurture/i,
  /^See qualification log above/i,
  /^CRM stage:/i,
  /^Moved on /i,
  /^Recorded on /i,
  /^Cold → Warm/i,
  /^Warm → Hot/i,
  /^Paused \/ Nurture/i,
  /^Future Prospect/i
];

function stripFollowUpTail(text) {
  return String(text || '')
    .replace(/\.\s*Next follow up is on[\s\S]*$/i, '')
    .replace(/\s*and agenda for the call is[\s\S]*$/i, '')
    .trim();
}

function isMeaningfulRemark(text) {
  const normalized = stripFollowUpTail(text);
  if (!normalized || normalized === '---' || normalized === 'Not named!') {
    return false;
  }
  return !SYSTEM_SALES_LOG_PATTERNS.some((pattern) => pattern.test(normalized));
}

function pickFollowUpRemark(followUps = []) {
  const dropped = followUps.find(
    (followUp) => followUp?.stage === 'Deal Dropped' && followUp?.log
  );
  if (dropped?.log && isMeaningfulRemark(dropped.log)) {
    return stripFollowUpTail(dropped.log);
  }

  for (const followUp of followUps) {
    const log = stripFollowUpTail(followUp?.log);
    if (!isMeaningfulRemark(log)) continue;
    if (followUp?.status === 'Inactive' || followUp?.completion_date) {
      return log;
    }
  }

  for (const followUp of followUps) {
    const log = stripFollowUpTail(followUp?.log);
    if (isMeaningfulRemark(log)) return log;
  }

  return null;
}

/**
 * Resolve the human remark for a lead — especially Closed Lost / Deal Dropped notes.
 * Prefer explicit drop logs over generic system sales-log entries.
 */
export function getLeadRemark(lead) {
  if (!lead) return null;

  const followUps = Array.isArray(lead.follow_ups) ? lead.follow_ups : [];
  const salesLogs = Array.isArray(lead.sales_logs) ? lead.sales_logs : [];
  const isClosedLost = lead.pstatus === 'Closed Lost' || lead.status === 'Inactive';

  if (isClosedLost) {
    const followUpRemark = pickFollowUpRemark(followUps);
    if (followUpRemark) return followUpRemark;
  }

  for (const entry of salesLogs) {
    const candidate = stripFollowUpTail(entry?.description || entry?.name);
    if (isMeaningfulRemark(candidate)) return candidate;
  }

  return pickFollowUpRemark(followUps);
}
